import Vue from 'vue'
import App from './App.vue'
import api from '@/api/api' // 导入api接口
import store from "@/store/store";
import {
  router
} from '@/router/index'
import 'lib-flexible/flexible'
import './assets/style/reset.less'
import './assets/font/iconfont.css'
import 'vant/lib/index.css'
import VCharts from 'v-charts'
import {
  i18n
} from '@/utils/languages'
// 引入 ECharts 主模块
let echarts = require('echarts/lib/echarts')
// 引入折线图/柱状图等组件
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/radar')
// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/legendScroll') //图例滚动 
import {
  List,
  Dialog,
  Cell,
  NavBar,
  Toast,
  Divider,
  Field,
  CellGroup,
  Picker,
  Icon,
  Tab,
  Tabs,
  Loading,
  RadioGroup,
  Radio,
  ImagePreview,
  Tag,
  Card,
  Popup,
  CheckboxGroup,
  Checkbox,
  Button,
  Search,
  Switch,
  Swipe,
  SwipeItem,
  DatetimePicker,
  Circle,
  Col,
  Row,
  Grid,
  GridItem,
  Image,
  Progress,
  Collapse,
  CollapseItem,
  ActionSheet,
  Area,
  GoodsAction,
  GoodsActionButton,
  Tabbar,
  TabbarItem,
  TreeSelect,
  Slider,
  GoodsActionIcon,
  PullRefresh,
  NoticeBar 
} from 'vant'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'video.js/dist/video-js.css'
Vue.use(Dialog).use(List).use(Field).use(CellGroup).use(Icon).use(Tab).use(Card).use(RadioGroup).use(Radio).use(ImagePreview).use(Button).use(Switch).use(DatetimePicker).use(Circle).use(Col).use(Row).use(Progress).use(Collapse).use(CollapseItem)
  .use(Cell).use(NavBar).use(Toast).use(Divider).use(Tabs).use(Loading).use(Tag).use(Picker).use(Popup).use(CheckboxGroup).use(Checkbox).use(Search).use(Swipe).use(SwipeItem).use(Grid).use(GridItem).use(Image).use(VCharts).use(ActionSheet).use(Area)
  .use(GoodsAction).use(GoodsActionButton).use(Tabbar).use(TabbarItem).use(TreeSelect).use(Slider).use(PullRefresh)
  .use(GoodsActionIcon).use(NoticeBar)
  .use(VueQuillEditor, {
    placeholder: '请填写详细内容'
  });
Vue.prototype.$echarts = echarts //vue全局注入echarts
Vue.config.productionTip = false;
Vue.prototype.$api = api;
let vue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
export default vue